<template>
  <v-row class="d-flex align-center justify-space-around" :class="{filteredBorder: filterActive}">
    <v-col sm="3">
      <AccountsInfoCard
        :imgSrc="require(`@/assets/icons/blue-users.png`)"
        title="Total de contas"
        :value="totalAccounts"
      />
    </v-col>
    <v-col sm="3">
      <ProceduresInfoCard
        :imgSrc="require(`@/assets/icons/blue-heart.png`)"
        title="Total de procedimentos"
        :value="totalProcedures"
      />
    </v-col>
    <v-col sm="3">
      <FinancesInfoCard
        :imgSrc="require(`@/assets/icons/green-card.png`)"
        title="Valor arrecadado"
        value="0"
      />
    </v-col>
    <v-col sm="3">
      <SavedPercentualInfoCard
        :imgSrc="require(`@/assets/icons/green-person-up.png`)"
        title="Percentual de salvamento"
        :value="sanitizedSavedPercentual"
      />
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";
import AccountsInfoCard from "@/components/molecules/Home/accounts-card";
import FinancesInfoCard from "@/components/molecules/Home/finances-card";
import ProceduresInfoCard from "@/components/molecules/Home/procedures-card";
import SavedPercentualInfoCard from "@/components/molecules/Home/saved-percentual-card";

export default {
  components: {
    AccountsInfoCard,
    FinancesInfoCard,
    ProceduresInfoCard,
    SavedPercentualInfoCard
  },
  computed: {
    filter() {
      const filterOptions = Object.assign({}, this.$store.getters.filterHome);
      if (filterOptions.startDate) {
        const [year, month, day] = filterOptions.startDate.split("-");
        filterOptions.startDate = `${day}/${month}/${year} 00:00:00`;
        filterOptions.startDate = this.formatDate(filterOptions.startDate);
      }
      if (filterOptions.endDate) {
        const [year, month, day] = filterOptions.endDate.split("-");
        filterOptions.endDate = `${day}/${month}/${year} 23:59:59`;
        filterOptions.endDate = this.formatDate(filterOptions.endDate);
      }
      return filterOptions;
    },
    filteredAccounts() {
      return this.accounts.filter(account => {
        if (!this.filter.country) {
          return account;
        }
        if (this.filter.country && !this.filter.state)
          return account.country === this.filter.country;
        if (this.filter.country && this.filter.state && !this.filter.city)
          return (
            account.country === this.filter.country &&
            account.state === this.filter.state
          );
        if (
          this.filter.country &&
          this.filter.state &&
          this.filter.city &&
          !this.filter.company
        )
          return (
            account.country === this.filter.country &&
            account.state === this.filter.state &&
            account.city === this.filter.city
          );
        if (
          this.filter.country &&
          this.filter.state &&
          this.filter.city &&
          this.filter.company
        )
          return (
            account.country === this.filter.country &&
            account.state === this.filter.state &&
            account.city === this.filter.city &&
            account.company === this.filter.company
          );
      });
    },
    filteredAccountsByDate() {
      return this.filteredAccounts.filter(account => {
        if (this.filter.startDate && !this.filter.endDate)
          return this.formatDate(account.createdAt) > this.filter.startDate;
        if (!this.filter.startDate && this.filter.endDate)
          return this.formatDate(account.createdAt) < this.filter.endDate;
        if (this.filter.startDate && this.filter.endDate)
          return (
            this.formatDate(account.createdAt) > this.filter.startDate &&
            this.formatDate(account.createdAt) < this.filter.endDate
          );
        return account;
      });
    },
    filteredProcedures() {
      return this.procedures.filter(procedure => {
        if (!this.filter.country) {
          return procedure;
        }
        if (this.filter.country && !this.filter.state)
          return procedure.procedureLocation.country === this.filter.country;
        if (this.filter.country && this.filter.state && !this.filter.city)
          return (
            procedure.procedureLocation.country === this.filter.country &&
            procedure.procedureLocation.state === this.filter.state
          );
        if (
          this.filter.country &&
          this.filter.state &&
          this.filter.city &&
          !this.filter.company
        )
          return (
            procedure.procedureLocation.country === this.filter.country &&
            procedure.procedureLocation.state === this.filter.state &&
            procedure.procedureLocation.city === this.filter.city
          );
        if (
          this.filter.country &&
          this.filter.state &&
          this.filter.city &&
          this.filter.company
        )
          return (
            procedure.procedureLocation.country === this.filter.country &&
            procedure.procedureLocation.state === this.filter.state &&
            procedure.procedureLocation.city === this.filter.city &&
            procedure.procedureLocation.company === this.filter.company
          );
      });
    },
    filteredProceduresByDate() {
      return this.filteredProcedures.filter(procedure => {
        if (this.filter.startDate && !this.filter.endDate)
          return (
            this.formatDate(procedure.procedureDatetime) > this.filter.startDate
          );
        if (!this.filter.startDate && this.filter.endDate)
          return (
            this.formatDate(procedure.procedureDatetime) < this.filter.endDate
          );
        if (this.filter.startDate && this.filter.endDate)
          return (
            this.formatDate(procedure.procedureDatetime) >
              this.filter.startDate &&
            this.formatDate(procedure.procedureDatetime) < this.filter.endDate
          );
        return procedure;
      });
    },
    totalAccounts() {
      return this.filteredAccountsByDate.length;
    },
    totalDeaths() {
      return this.filteredProceduresByDate.filter(
        procedure => !procedure.patientSaved
      ).length;
    },
    totalProcedures() {
      return this.filteredProceduresByDate.length;
    },
    totalRecovered() {
      return this.filteredProceduresByDate.filter(
        procedure => procedure.patientSaved
      ).length;
    },
    savedPercentual() {
      return ((this.totalRecovered / this.totalProcedures) * 100).toFixed();
    },
    sanitizedSavedPercentual() {
      return this.savedPercentual === 'NaN' ? 'Sem Dados' : this.savedPercentual;
    }
  },
  methods: {
    formatDate(value) {
      return moment(value, [
        "DD-MM-YYYY HH:mm:ss",
        "YYYY-MM-DDTHH:mm:ss.SSSSZ"
      ]);
    }
  },
  props: {
    accounts: {
      type: Array,
      required: true
    },
    procedures: {
      type: Array,
      required: true
    },
    filterActive: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style scoped>
.filteredBorder {
  border: 2px solid #6464ff;
  border-radius: 10px;
}
</style>
